<script setup>
import { WdsAccordion, WdsAccordionItem } from '@wds/components';

const props = defineProps({
  tag: {
    type: String,
    required: false,
    default: 'div',
  },
  content: {
    type: Array,
    required: true,
  },
});

// ### EMITTED EVENTS
const emit = defineEmits(['expand']);

// ### METHODS
function toggleFaqItem(event, faqClickedIndex) {
  if (event?.status === 'expanded') {
    emit('expand', faqClickedIndex);
  }
}
</script>

<template>
  <component
    :is="tag"
    v-if="content && content?.length"
    class="faq-section"
  >
    <h2 class="faq-section-title">
      {{ $t('t_FAQS') }}
    </h2>
    <WdsAccordion>
      <WdsAccordionItem
        v-for="(faqQuery, faqIndex) in props.content"
        :key="faqIndex"
        @item-expanded="toggleFaqItem($event, faqIndex + 1)"
      >
        <template #header>
          <h3 class="faq-item-question">
            {{ faqQuery.header?.trim() }}
          </h3>
        </template>
        <template #content>
          <div
            class="faq-item-answer"
            v-html="faqQuery.content"
          />
        </template>
      </WdsAccordionItem>
    </WdsAccordion>
  </component>
</template>

<style lang="scss" scoped>
.faq-section {
  .faq-section-title {
    @include title-3-bld;

    margin-bottom: $wds-spacing-l;
    color: $wds-color-ink-darker;
  }

  :deep(.faq-item-question) {
    @include title-6-reg;

    font-weight: $wds-font-weight-bold;
    text-align: left;
  }

  :deep(.faq-item-answer) {
    @include body-1-reg;

    padding: $wds-spacing-xs;

    a {
      @include body-1-bld;

      color: $wds-color-ink-dark;
      text-decoration: underline;
      outline: none;
      padding: $wds-spacing-s 0;
      background-color: transparent;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
        color: $wds-color-ink;
      }

      &:focus-visible {
        box-shadow:
          0 0 0 $wds-spacing-xxs $wds-color-white,
          0 0 0 $wds-spacing-xs $wds-color-ink-darker;
      }
    }
  }

  @include desktop {
    .faq-section-title {
      @include title-1-bld;
    }
  }
}
</style>
